import { SWEDEN_REGEX } from '../constants/texts';
import { CallMeAction, CallMeActionKind, CallMeFormState } from '../types';

export function reducer(
  state: CallMeFormState,
  action: CallMeAction
): CallMeFormState {
  const { type, payload } = action;
  const re = new RegExp(SWEDEN_REGEX);
  switch (type) {
    case CallMeActionKind.ENTER_NAME:
      if (payload.length === 0) {
        return {
          ...state,
          name: payload,
          formErrors: {
            nameInvalid: true,
            numValidity: state.formErrors.numValidity
          }
        };
      }
      return {
        ...state,
        name: payload,
        formErrors: {
          nameInvalid: false,
          numValidity: state.formErrors.numValidity
        }
      };
    case CallMeActionKind.VALIDATE_ENTER_NUM:
      if (payload.length === 0) {
        return {
          ...state,
          number: state.number,
          formErrors: {
            numValidity: 'EMPTY',
            nameInvalid: state.formErrors.nameInvalid
          }
        };
      } else if (!re.test(payload)) {
        return {
          ...state,
          number: state.number,
          formErrors: {
            numValidity: 'INVALID',
            nameInvalid: state.formErrors.nameInvalid
          }
        };
      } else {
        return {
          ...state,
          number: payload,
          formErrors: {
            numValidity: 'VALID',
            nameInvalid: state.formErrors.nameInvalid
          }
        };
      }
    case CallMeActionKind.ENTER_NUM:
      return {
        ...state,
        number: payload
      };
    case CallMeActionKind.CHOOSE_DAY:
      return {
        ...state,
        day: payload
      };
    case CallMeActionKind.CHOOSE_TIME:
      return {
        ...state,
        time: payload
      };
    case CallMeActionKind.SELECT_CUSTOMER_RELATIONSHIP:
      return {
        ...state,
        isCustomer: payload
      };
    case CallMeActionKind.SET_LOADING:
      return {
        ...state,
        callMeActionStatus: 'loading'
      };
    case CallMeActionKind.SET_SUCCESS:
      return {
        callMeActionStatusMessage: payload,
        callMeActionStatus: 'submittedSuccessfully',
        isCustomer: '',
        formErrors: {
          nameInvalid: false,
          numValidity: 'VALID'
        },
        name: '',
        day: '',
        time: '',
        number: ''
      };
    case CallMeActionKind.SET_FAILURE:
      return {
        callMeActionStatusMessage: payload,
        callMeActionStatus: 'submittedFailure',
        isCustomer: '',
        formErrors: {
          nameInvalid: false,
          numValidity: 'VALID'
        },
        name: '',
        day: '',
        time: '',
        number: ''
      };
    default:
      return state;
  }
}
